import {
  Flex, Input, Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import useDebounce from '../../helpers/useDebounce';

const InputSetting = ({
  label, value, onChange, regex, errorMessage,
}) => {
  const [isValid, setValid] = useState(true);
  const [v, setV] = useState(value);

  const debouncedRequest = useDebounce(() => {
    const valid = regex.test(v);
    setValid(valid);
    if (valid) {
      onChange(v);
    }
  });

  const handleCustomSize = (e) => {
    setV(e);
    debouncedRequest();
  };

  const handleKeyDown = (e) => {
    let valid = v.match(/([0-9]+)(.*)/);
    if (!valid) valid = ['0px', '0', 'px'];
    if (valid.length !== 3) return;
    switch (e.keyCode) {
      case 40: // key down
        if (valid[1] === '0') return;
        handleCustomSize(`${valid[1] - 1}${valid[2]}`);
        break;
      case 38: // key up
        handleCustomSize(`${Number(valid[1]) + 1}${valid[2]}`);
        break;
      default:
    }
  };

  return (
    <Flex flexDir="column">
      <Flex mb="0" alignItems="center">
        <Text w="126px" flexShrink="0">{label}</Text>
        <Input onChange={(e) => handleCustomSize(e.target.value)} value={v} onKeyDown={handleKeyDown} />
      </Flex>
      {!isValid && <Text color="red.600" fontSize="xs" fontWeight="bold">{errorMessage}</Text>}
    </Flex>
  );
};

export default InputSetting;
